import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { Line } from './Line';
import { Step } from './Step';
import styles from './StepBar.module.scss';
export const StepBar = ({ activeIndex = 1, steps, testId }) => {
    return (_jsx("div", { className: `d-flex mx-auto py-2x ${styles.stepBar}`, "data-testid": testId ?? 'step-bar', children: steps.map((step, ix) => (_jsxs(Fragment, { children: [ix > 0 && _jsx(Line, { position: ix - 1, activeIndex: activeIndex }), _jsx(Step, { activeIndex: activeIndex, position: ix, step: step }, step.title)] }, step.title))) }));
};
